// Flat Puzzle 1 - alun tietokone
import "./puzzleWindow.css";
import { html, render } from "lit-html";
import pointerLockEvents from "../helpers/pointerLockEvents.js";
import { customCameraHelpers } from "../babylonScene";
import { mobileOrNot } from "~/src/helpers/mobileDetect.js";
import { JoystickUtils } from "~/src/helpers/virtualJoystick.js";
import { classMap } from "lit-html/directives/class-map.js";
import { infoStatus} from "../infoScreen"
let usable = true;

const turnOffTemporarily = () => {
  //this is to avoid bugging/unwanted openings 
  
  usable = false;
  setTimeout(() => (usable = true), 1000);
};

const buildPuzzle1 = function (options) {
  if (!usable) return null
  let border = options && options.border;
  let exitCallback = options && options.exitCallback;
  let blurred = options && options.blurred;
  let info = options && options.info;
  let hidden = options && options.hidden;
  let removeContainer = options && options.removeContainer;
  console.log(removeContainer)
  if(!info) {
  // not info modal, so disable it
    infoStatus.disabled = true;
  }
  if (customCameraHelpers.getHelpers().detachControl) {
    customCameraHelpers.getHelpers().detachControl();
  }
  pointerLockEvents.unlockPointerFromCanvas();

  const getContainer = () => {
    const container = document.getElementById("modal-container");
    if (!container) {
      const container = document.createElement("div");
      container.id = "modal-container";
      blurred && container.classList.add("blurred");
      document.body.append(container);
      return container;
    } else {
      if (blurred && container.classList.contains("animatedOut")) {
        container.classList.remove("animatedOut");
      }

      if (blurred && !container.classList.contains("blurred")) {
        container.classList.add("blurred");
      }

      return container;
    }
  };

  const container = getContainer();

  const createModal = ({ animated, animation, hidden }) => {
    let classes1 = {
      animated: animated,
      [animation]: animated,
      blurred: blurred,
    };
    let classes2 = { shadow_border: border, blurred: blurred };

    let classesExitB = {
      ["exit-button"]: !blurred,
      ["exit-button-green"]: blurred && !info,
      ["exit-button-info"]: info
    };

    return html`
      <div
        id="modal"
        class=${classMap(classes1)}
        style="display: ${hidden ? "none" : "initial"}"
      >
        <button class=${classMap(classesExitB)} @click=${exitButtonCallback}>
          X
        </button>
        <div id="modal-content" class=${classMap(classes2)}></div>
      </div>
    `;
  };

  function exitButtonCallback(event, options) {
    if(!removeContainer) {
        removeContainer = options && options.removeContainer ? options.removeContainer : null;
    }
    turnOffTemporarily();
    if (event) {
      event.stopPropagation();
    }
    // this adds the animation classes
    customCameraHelpers.getHelpers().attachControl();
   
    if(document.querySelector(".exit-button")) {

    document
    .querySelector("#modal").insertAdjacentElement('afterbegin', document.querySelector(".exit-button"))

    }
    if (exitCallback) exitCallback();


    if (mobileOrNot()) {
      JoystickUtils.reveal();
    }
    render(createModal({ animated: false, animation: "zoomOut" }), container);
    container.classList.add("animatedOut");
    container.classList.remove("blurred")
    container.style.display = "none"
    if(removeContainer) {
    container.remove();
    }
    
    infoStatus.disabled = false;
    pointerLockEvents.lockPointerToCanvas();
  }

  container.style.display = "flex";

  if (mobileOrNot()) {
    JoystickUtils.hide();
  }
  render(
    createModal({
      animated: !mobileOrNot(),
      animation: "zoomIn",
      hidden: hidden ? hidden : false,
    }),
    container
  );

  window.currentModalExit = exitButtonCallback

  return {
    element: container.querySelector("#modal-content"),
    exit: exitButtonCallback,
  };
};

export default buildPuzzle1;
